import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Varient from '../../assets/img/varient.png'
import { useForm } from 'react-hook-form';
import KEYS from "../../env/env";
// import secureLocalStorage from 'react-secure-storage';
import Loader from "../../components/Loader";
import { loginwithgoogle } from "./LoginWithGoogle";
import "../../design/css/login.css";
import doneIcon from "../../assets/loginimg/doneicn.svg"
import eyeIcon from "../../assets/loginimg/eyeicn.svg"
import googleIcon from "../../assets/loginimg/googleglogo.svg"
import teedexlogo from "../../assets/loginimg/teedexlogo.svg"



function Signup() {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [emailValid, setEmailValid] = useState(false);
  const [emailValue, setEmailValue] = useState("");


  const navigate = useNavigate();
  const [errMsg, setErrorMsg] = useState(null);
  const [params] = useSearchParams();
  const plan = params.get('plan');

  if (plan) {
    localStorage.setItem('userselectedplanid', plan)
  } else {
    if (localStorage.getItem('userselectedplanid')) {
      localStorage.removeItem('userselectedplanid')
    }
  }



  const handleEmailChange = (e) => {
    setValue('emailid', e.target.value);
    const email = e.target.value;
    setEmailValue(email);

    // Email regex pattern
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    // Check if email is valid
    if (email && emailRegex.test(email)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }
  };


  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(prev => !prev);
  };

  const { register, formState: { errors }, handleSubmit, setValue } = useForm();

  useEffect(() => {
    const email = searchParams.get('email');
    if (email) {
      setValue('emailid', email);
      handleEmailChange({ target: { value: email } });
    }
  }, [searchParams.get('email')]);

  var sign_up = (data) => {
    setErrorMsg(null); 
    setLoading(true)
    if (data.password !== data.confirmpass) {
      setErrorMsg("Password and confirm password should be same");
      setLoading(false);
      return false;
    }
    try {
      let obj = {
        email: data.emailid
      }
      window.gtag("event", "Signup User", obj);
    } catch (error) {

    }
    var dataToPost = {
      email: data.emailid,
      password: data.password
    }

    fetch(KEYS.apiPath + 'user/sign-up', {
      body: JSON.stringify(dataToPost),
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then(response => response.json())
      .then(val => {
        if (val && +val?.resultFlag === 1) {
          setErrorMsg(null);
          // secureLocalStorage.setItem('Login', val?.response?.token)
          localStorage.setItem("Login", val?.response?.token); 
          localStorage.setItem("token", val?.response?.token)
          localStorage.setItem('users_email', data.emailid);
          navigate('/verify-email' + window.location.search)
        } else {
          setErrorMsg(val?.message);
        }
        setLoading(false)
      }).catch(err => {
        setLoading(false)
        setErrorMsg(err?.message ? err?.message : 'Something went wrong, Please try again later!')
      })

  }



  return (
    <>
      {loading && <Loader />}
      {/* <div id="main-container" className="container-fluid main"> */}
      {/* <div className="sidemenu d-flex flex-column justifycontent-between min-vh-100">
          <div className="text-center mt-3">
            <ul className="nav nav-pills flex-column">
              <li>
                <img src={Varient} alt="Varient logo" style={{ width: '50px', top: 0 }} />
              </li>
            </ul>
          </div>
        </div> */}

      {/* <section className="home">
          <div className="container login-container"> */}
      {/* <div className="row mt-4">
              <div className="mb-4">
                <ul className="d-flex col-11 login-tabs">
                  <li className="">Signup</li>
                  <li className="mx-2">Payment</li>
                  <li className="mx-2">Register</li>
                </ul>
              </div>
            </div> */}
      {/* <div className="row my-5">
              <div className="col-4">
                <div className="login">
                  <h3 className="text-center">Sign Up</h3>
                  <p>Welcome back! Please enter your details</p>
                 
                  <form onSubmit={handleSubmit(sign_up)}>

                    <input type="email" name="email" placeholder="Email" {...register("emailid", { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i })} />
                    {errors.emailid?.type === "required" && (<span className="text-danger">Email is required.</span>)}
                    {errors.emailid?.type === "pattern" && (<span className="text-danger">Please enter valid email.</span>)}
                    <div style={{ position: 'relative' }}>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        placeholder="Password"
                        style={{ paddingRight: '30px' }} {...register("password", { required: true })}
                      />
                      {errors.password?.type === "required" && (<span className="text-danger">Password is required.</span>)}
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                        onClick={togglePasswordVisibility}
                        style={{ position: 'absolute', top: '40%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}
                      />
                    </div>

                    <div style={{ position: 'relative', marginBottom: '15px' }}>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        placeholder="Confirm Password"
                        style={{ paddingRight: '30px' }} {...register("confirmpass", { required: true })}
                      />
                      {errors.confirmpass?.type === "required" && (<span className="text-danger">Confirm password is required.</span>)}
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                        onClick={togglePasswordVisibility}
                        style={{ position: 'absolute', top: '40%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}
                      />
                    </div>
                    <p className="text-danger">{(errmsg != null) ? errmsg : ''}</p>
                    <input className="submit" type="submit" value="Sign Up" />
                  </form>

                  <p >Already have account? <Link to={"/Login" + window.location.search} className="login-a mx-2">Login</Link></p>
                  <p className="login_signup">By creating an account, you agree to our <Link to={'/termspolicy'}>Terms & policies </Link>.</p>
                </div>
              </div>

              <div className="col-8 d-flex justify-content-center align-items-center">
                <div className="login-title">
                  <img style={{ maxWidth: '300px' }} src={"/assets/images/logo.svg"} alt="title" />
                  <p style={{ fontSize: '90px' }}>Join the Crafters</p>
                </div>
              </div>

            </div>
          </div>


        </section>
      </div> */}


      <div className="newLoginBody">
        <div className="newLoginBodyText">
          <div className="newLoginFormContainer newLoginFormBlock">
            <h1>Signup</h1>
            <p>Create account on teedex.in</p>
            <div className="googlelogin">
              <a href="#" className="googleLoginButton" onClick={(e) => {
                e.preventDefault();
                loginwithgoogle(); // trigger redirect
              }}>
                <img src={googleIcon} alt="Google Logo" />
                <span>Continue with Google</span>
              </a>
            </div>
            <div className="orLogin"><span>or</span></div>
            <form onSubmit={handleSubmit(sign_up)}>
              <div className="inputContainer">
                {/* <input type="email" id="email" name="email" placeholder="Email" value="New user @email.com" required> */}
                <input type="email" name="email" placeholder="Email" {...register("emailid", { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i })} onChange={handleEmailChange} />
                {errors.emailid?.type === "required" && (<span className="text-danger">Email is required.</span>)}
                {errors.emailid?.type === "pattern" && (<span className="text-danger">Please enter valid email.</span>)}
              
              
              {emailValid && <div class="verified"><img src={doneIcon} alt="" /></div>}
              
              
              </div>
              <div className="inputContainer">
                {/* <input type="password" id="password" name="password" placeholder="Password" required> */}
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Password"
                  {...register("password", { required: true })}
                />

                <div
                  className={`showPassword ${showPassword ? "showed" : ""}`}
                  onClick={togglePasswordVisibility}>
                  <img src={eyeIcon} alt="eye icon" />
                </div>
              </div>
              {errors.password?.type === "required" && (
                <div className="text-danger" style={{ marginBottom: ".365vw" }}>Password is required.</div>
              )}
              <div className="inputContainer">
                {/* <input type="password" id="password" name="password" placeholder="Confirm Password" required> */}
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmpass"
                  placeholder="Confirm Password"
                  {...register("confirmpass", { required: true })}
                />

                <div
                  className={`showConfirmPassword ${showConfirmPassword ? "showed" : ""}`}
                  onClick={toggleConfirmPasswordVisibility}>
                  <img src={eyeIcon} alt="eye icon" />
                </div>
              </div>

              {errors.confirmpass?.type === "required" && (
                <div className="text-danger" style={{ marginBottom: ".365vw" }}>Confirm password is required.</div>
              )}

              <div className="inputContainer">
                <button type="submit" className="loginButton">Signup</button>
              </div>

              
              {errMsg && (
                <div className="text-danger" style={{ marginBottom: ".365vw" }}>{errMsg}</div>
              )}

            </form>
          </div>
          <div className="formTnc newLoginFormBlock">
            By signing up for teedex you acknowledge that you agree to teedex <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
          </div>
          <div className="formTeedexLogo newLoginFormBlock">
            <img src={teedexlogo} alt="Teedex Logo" />
          </div>
          <div className="formCopyR newLoginFormBlock">© 2025 Teedex All Rights Reserved</div>
        </div>

        <div className="newLoginBodyImg"></div>
      </div>
    </>
  );
}

export default Signup;